import { BlogTable } from "../../../../src/components/Blog/postElements/BlogTable";
import { PostIntro } from "../../../../src/components/Blog/postElements/PostIntro";
import { FullWidthImage } from "../../../../src/components/Blog/postElements/FullWidthImage";
import { HtmlElement } from "../../../../src/components/Blog/postElements/HtmlElement";
import { BannerMobileApp } from "../../../../src/components/Blog/postElements/BannerMobile";
import { Quote } from "../../../../src/components/Blog/postElements/Quote";
import * as React from 'react';
export default {
  BlogTable,
  PostIntro,
  FullWidthImage,
  HtmlElement,
  BannerMobileApp,
  Quote,
  React
};